export const HELP_CARDS = [
  { title: 'If you\'ve chosen our prescription delivery service\n', link: '/help-centre/delivery' },
  // { title: 'If you\'re collecting your prescription in-person from your local pharmacy', link: '/help-centre/self-pickup' },
  { title: 'Frequently asked questions', link: '/help-centre/faqs' },
];
